import React, { useEffect } from "react";
import { connect } from "react-redux";
import authActions from "../../../store/actions/authActions";
import mobileValidtion from "../../../validtions/mobile";
import authMessages from "../../../messages/auth";
import { Redirect } from "react-router-dom";
import typeMessageClass from "../../../messages/typeClass";
import typeMessages from "../../../messages/type";

function EnterMobileForLogin({
  isUserLoggedIn,
  authStatus,
  hasMessage,
  typeMessage,
  message,
  sendMobileUserForLoign,
  errorEnterMobileNumber,
}) {
  if (isUserLoggedIn === true) {
    return <Redirect to="/" />;
  }

  let messageComponent;
  if (hasMessage == true) {
    messageComponent = (
      <div className="w-100">
        <p className={typeMessageClass[typeMessage]}>
          <span> {message}</span>
        </p>
      </div>
    );
  }

  if (authStatus === authActions.SEND_CODE_SMS_TO_USER) {
    return <Redirect to="/login-with-mobile" />;
  }

  const submitFormEnterMobileNumberForLoign = (e) => {
    e.preventDefault();
    const userMobile = document.getElementById("num-enter-user-mobile").value;
    if (!validateMobileNumber(userMobile)) {
      const message = {
        type: typeMessages.ERROR,
        text: authMessages.USER_MOBILE_WRONG,
      };
      errorEnterMobileNumber(message);
      return;
    }

    sendMobileUserForLoign(userMobile);
  };
  window.onload = function () {
    document.getElementById("num-enter-user-mobile").focus();
  };

  return (
    <>
      <div className="login-box">
        <div className="login-logo mb-0">
          <b className="bg-warning text-primary px-3">ورود بدون ثبت نام</b>
        </div>

        <div className="card">
          <div className="card-body login-card-body">
            {messageComponent}

            <p className="login-box-msg">
              جهت ورود به پنل شماره موبایل خود را وارد کنید.
            </p>
            <form onSubmit={submitFormEnterMobileNumberForLoign}>
              <div className="input-group mb-3">
                <input
                  type="number"
                  id="num-enter-user-mobile"
                  className="form-control"
                  placeholder=" مثال : 09121234567"
                />
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  id="btn-enter-mobile-login"
                  className="btn btn-primary "
                >
                  ارسال
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

const validateMobileNumber = (mobile) => {
  if (
    mobileValidtion.isNumericMobile(mobile) &&
    mobileValidtion.validMobileNumber(mobile) &&
    mobileValidtion.lenghtMobileNumber(mobile)
  ) {
    return true;
  } else {
    return false;
  }
};

const mapStateToProps = (state) => {
  return {
    isUserLoggedIn: state.main.isUserLoggedIn,
    authStatus: state.main.authStatus,
    hasMessage: state.main.hasMessage,
    typeMessage: state.main.typeMessage,
    message: state.main.message,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendMobileUserForLoign: (action) => {
      dispatch({
        type: authActions.USER_ENTER_MOBILE_FOR_LOGIN,
        payload: action,
      });
    },
    errorEnterMobileNumber: (action) => {
      dispatch({
        type: authActions.MOBILE_USER_WRONG,
        payload: {
          typeMessage: action.type,
          message: action.text,
        },
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EnterMobileForLogin);
